import { Tab } from "@headlessui/react";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import React, { FC, Fragment, useContext, useEffect, useState } from "react";
import visaPng from "images/vis.png";
import mastercardPng from "images/mastercard.svg";
import { GuestsObject } from "components/HeroSearchForm/type";
import StartRating from "components/StartRating/StartRating";
import NcModal from "shared/NcModal/NcModal";
import ModalSelectDate from "components/ModalSelectDate";
import converSelectedDateToString from "utils/converSelectedDateToString";
import ModalSelectGuests from "components/ModalSelectGuests";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { GlobalDataContext } from "contexts/GlobalData";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { useNavigate, useParams } from "react-router-dom";
import { requestAPI } from "utils/api";

export interface CheckOutPagePageMainProps {
  className?: string;
}

const CheckOut: FC<CheckOutPagePageMainProps> = ({
  className = "",
}) => {

	const { id } = useParams();

	const navigate = useNavigate ();

	const [ info, setInfo ] = useState <any> ({});
	const [ reserveAmount, setReserveAmount ] = useState <any> (0);
	const [ amount, setAmount ] = useState <any> (0);
	const [ reserveConfirmPrice, setReserveConfirmPrice ] = useState <any> (0);
	// const {
	// 	toast,
	// } = useContext(UIContext);  
	const { 
		initData,
		get,
		set,
	} = useContext (GlobalDataContext);

	// (async () => {
	// 	console.log('dddddddd', await get("productOrderInfo"));
	// })()

	useEffect(() => {
		(async () => {

			console.log('r11 dkdkdkdkdk', id)

			//const _info = await get("productOrderInfo")

            if (initData.token_info.permission_group === "guest") {
				
				navigate('/me')	
			} else {
	
				//const _info = await get("productOrderInfo")
				
				const res: any = await requestAPI('GET', `v1/reserve/${id}`, null);
				
				let _reserveAmount = 0;
				let _amount = 0;
				
				res.data.info.product_priceOptions.forEach((item: any) => {
					_reserveAmount = _reserveAmount + item.amount;
					_amount = _amount + item.amount * item.price;
				});
				
				setReserveAmount(_reserveAmount);	
				setAmount(_amount);
				setReserveConfirmPrice(_amount * 0.1);
				setInfo(res.data.info);
			}
	
		})();
	}, []);
	
	if (Object.keys(info).length ===0) return (<></>);

  const renderSidebar = () => {
    return (
		<div className="w-full flex flex-col sm:rounded-2xl lg:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 px-0 sm:p-6 xl:p-8">
			<div className="flex flex-col sm:flex-row sm:items-center">
				<div className="flex-shrink-0 w-full sm:w-40">
					<div className=" aspect-w-4 aspect-h-3 sm:aspect-h-4 rounded-2xl overflow-hidden">
						<img
							alt=""
							className="absolute inset-0 object-cover"
							sizes="200px"
							src="https://images.pexels.com/photos/6373478/pexels-photo-6373478.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
						/>
					</div>
				</div>
				<div className="py-5 sm:px-5 space-y-3">
					<div>
						<span className="text-sm text-neutral-500 dark:text-neutral-400 line-clamp-1">
							Hotel room in Tokyo, Jappan
						</span>
						<span className="text-base font-medium mt-1 block">
							The Lounge & Bar
						</span>
					</div>
					<span className="block  text-sm text-neutral-500 dark:text-neutral-400">
						2 beds · 2 baths
					</span>
					<div className="w-10 border-b border-neutral-200  dark:border-neutral-700"></div>
					<StartRating />
				</div>
			</div>
			<div className="flex flex-col space-y-4">
				<h3 className="text-2xl font-semibold">Price detail</h3>
				<div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
					<span>$19 x 3 day</span>
					<span>$57</span>
				</div>
				<div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
					<span>Service charge</span>
					<span>$0</span>
				</div>

				<div className="border-b border-neutral-200 dark:border-neutral-700"></div>
				<div className="flex justify-between font-semibold">
					<span>Total</span>
					<span>$57</span>
				</div>
			</div>
		</div>
    );
  };

  const renderMain = () => {
    return (
		<div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-4 px-0 sm:p-6 xl:p-8">
			<h3 className="text-2xl font-semibold">상품 정보</h3>
			<div>	
				<NcModal
					renderTrigger={(openModal) => (
					<span
						onClick={() => openModal()}
						className="block lg:hidden underline cursor-pointer"
					>
						예약 상품 정보
					</span>
					)}
					renderContent={renderSidebar}
					modalTitle="Booking details"
				/>
			</div>
			<div className="border-b border-neutral-200 dark:border-neutral-700"></div>

			<div>
				<h3 className="text-2xl font-semibold">예약 정보</h3>
				<div className="mt-4">
					<h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
						인원
					</h3>
					<span className="block mt-2 text-neutral-500 dark:text-neutral-400">
						{reserveAmount}명
					</span>
                </div>
				<div className="mt-4">
					<h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
						주문금액
					</h3>
					<span className="block mt-2 text-neutral-500 dark:text-neutral-400">
						{amount.toLocaleString('ko-KR')}원
					</span>
                </div>
				<div className="mt-4">
					<h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
						주문상세 내역
					</h3>
					<span className="block mt-2 text-neutral-500 dark:text-neutral-400">
						{info.product_priceOptions.map((item: any) => {
							if (item.amount === 0) {
								return (<></>);
							} else {
								return (
									<div>
										<span className="flex block mt-2 text-neutral-500 dark:text-neutral-400">
											<div className="w-full">
												{item.label} ({item.amount}명)
											</div>
											<div>
												
											</div>
											<div className="text-right w-[120px]">
												{(item.price * item.amount).toLocaleString('ko-KR')}원
											</div>
										</span>
									</div>
								);
							}
						})}
					</span>
                </div>
			</div>
			<div className="border-b border-neutral-200 dark:border-neutral-700"></div>

			<div>
				<h3 className="text-2xl font-semibold">입금 정보</h3>

				<div className="mt-4">
					<h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
						예약 확정금액(주문 금액의 10%)
					</h3>
					<span className="block mt-2 text-neutral-500 dark:text-neutral-400">
						{reserveConfirmPrice.toLocaleString('ko-KR')}원
					</span>
                </div>
				<div className="mt-4">
					<h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
						예약금 입금 마감일 안내
					</h3>
					<span className="block mt-2 text-neutral-500 dark:text-neutral-400">
						우선 입금자 순서로 마감
					</span>
                </div>
				<div className="mt-4">
					<h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
						입금 계좌번호
					</h3>
					<span className="block mt-2 text-neutral-500 dark:text-neutral-400">
						은행: 우리은행
					</span>
					<span className="block mt-2 text-neutral-500 dark:text-neutral-400">
						계좌번호: 1005-704-713607
					</span>
					<span className="block mt-2 text-neutral-500 dark:text-neutral-400">
						예금주: 주식회사 올타
					</span>
                </div>
			</div>

			<div className="px-4 py-3 bg-white dark:bg-neutral-900 border-t border-neutral-200 dark:border-neutral-700 flex justify-between">
							
				<div></div>
				<ButtonPrimary
					sizeClass="px-6 py-3 !rounded-xl"
					onClick={() => {navigate('/home');}}
				>
					나가기
				</ButtonPrimary>
			</div>

		</div>
    );
  };

  return (
	<div className={`container relative nc-SectionLatestPosts overflow-y ${className} sm:w-[768px] h-screen bg-white !p-0`}>
		<div className={`nc-CheckOutPagePageMain ${className}`}>
			<div className="pt-10" />
			<main className="container flex flex-col-reverse">
				<div className="w-full">{renderMain()}</div>
			</main>
		</div>
	</div>
  );
};

export default CheckOut;
